import React from 'react';

function Traceability() {

  return (
    <React.Fragment>
      <h1>Traceability</h1>
    </React.Fragment>
  );
}

export default Traceability;
